import React from "react";
import "./WhyChooseUs.css";

const benefits = [
  {
    id: 1,
    title: "Skillfluencers That Inspire",
    description:
      "Learn directly from industry experts and passionate experts who’ve walked the talk and now lead the way.",
  },
  {
    id: 2,
    title: "Flexible Scheduling",
    description:
      "Learn or teach at your own pace. Whether you’re a night owl or an early bird, Upskillmeet fits your schedule.",
  },
  {
    id: 3,
    title: "Secure Payments, Hassle Free",
    description:
      "Transparent pricing and safe transactions we ensure every skill exchange is smooth and trustworthy.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us">
      <h2 className="section-title">The Upskillmeet Advantage</h2>
      <div className="benefits-grid">
        {benefits.map((benefit) => (
          <div key={benefit.id} className="benefit-card">
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
